import { createSlice } from "@reduxjs/toolkit";
import { TimeslotResponseDto } from "../../shared/dtos/timeslot/TimeslotResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const timeslotSlice = createSlice({
  name: "timeslot",
  initialState: getInitialCrudState<TimeslotResponseDto>(),
  reducers: {
    ...generateCrudReducers<TimeslotResponseDto>(),
  },
});

export const timeslotActions = timeslotSlice.actions;
export default timeslotSlice.reducer;
